var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"save-img-box"},[_c('div',{staticClass:"content-box",on:{"click":_vm.saveImg}},[_c('img',{attrs:{"src":require("@/assets/html5/icon_download@2x.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.$t('APP-FIELD-0138')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }